import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import "./CategoryDropdown.css";
import getDistinctExtensionsCategories from "../../../../utils/ExtensionHandlingUtils/getDistinctExtensionsCategories";

const CategoryDropdown = ({ onCategoryChange, value = null, error, helperText }) => {
    const [categories, setCategories] = useState([]);
    const [localCategory, setLocalCategory] = useState(value);
    const [isCustomCategory, setIsCustomCategory] = useState(false);
    const [customCategory, setCustomCategory] = useState("");

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                let distinctCats = await getDistinctExtensionsCategories();
                distinctCats = distinctCats.filter(cat => cat.trim() !== ""); // Remove empty categories
                setCategories(distinctCats);
            } catch (error) {
                console.error("Error fetching distinct extension categories:", error);
            }
        };
        fetchCategories();
    }, []);

    const handleCategoryChange = (e) => {
        setLocalCategory(e.value);

        if (e.value === "custom") {
            setIsCustomCategory(true);
            onCategoryChange(customCategory || "");
        } else {
            setIsCustomCategory(false);
            setCustomCategory("");
            onCategoryChange(e.value);
        }
    };

    const handleClearCustomCategory = () => {
        setCustomCategory("");
        setLocalCategory(null);
        setIsCustomCategory(false);
        onCategoryChange("");
    };

    return (
        <div className="form-group">
            <label htmlFor="category">Category<span style={{ color: 'red' }}>*</span></label>
            {!isCustomCategory ? (
                <Dropdown
                    id="category"
                    className={`p-dropdown ${error ? 'p-invalid' : ''}`} // Apply error styling
                    checkmark={true} highlightOnSelect={false}
                    value={localCategory}
                    options={[
                        ...categories.map((cat) => ({ label: cat, value: cat })),
                        { label: "Custom Category", value: "custom", className: "custom-category-option" },
                    ]}
                    onChange={handleCategoryChange}
                    placeholder="Select a Category"
                />
            ) : (
                <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                    <InputText
                        className={`p-text pr-10 ${error ? 'p-invalid' : ''}`} // Apply error styling
                        value={customCategory}
                        onChange={(e) => {
                            setCustomCategory(e.target.value);
                            onCategoryChange(e.target.value);
                        }}
                        placeholder="Enter custom category"
                        style={{ width: "100%" }}
                    />
                    <Button
                        icon="pi pi-times"
                        className="p-button-rounded p-button-text cust-btn"
                        onClick={handleClearCustomCategory}
                        tooltip="Clear Custom Category"
                        style={{
                            position: "absolute",
                            right: "5px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            padding: "5px",
                            height: "80%",
                            background: "transparent",
                            border: "none",
                            boxShadow: "none",
                            color: "black",
                        }}
                    />
                </div>
            )}
            {error && <small className="p-error">{helperText}</small>} {/* Display error message */}
        </div>
    );
};

export default CategoryDropdown;
